import {endpoints} from './endpoints'
import request from '../../request'

export function getPaymentOrders(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getPaymentOrders,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getPaymentOrder(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getPaymentOrder,
			method: 'get',
			params: data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createPaymentOrder(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createPaymentOrder,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function createManualPayment(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.createManualPayment,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}